import axios from "axios";
export default {
    props: {
        intervalMin: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            timerId: undefined
        };
    },
    methods: {
        async checkVersion() {
            this.loading = true;
            try {
                const res = await axios({
                    baseURL: window.location.origin,
                    url: `/${process.env.VUE_APP_VERSION_TIMESTAMP}.txt`,
                    method: "head"
                });
                if (
                    res.headers &&
                    res.headers["content-type"] &&
                    res.headers["content-type"].includes("text/html")
                ) {
                    this.dialog = true;
                }
            } catch (e) {
                console.log(e);
            }
            this.loading = false;
        },
        handleSubmit(update) {
            this.dialog = false;
            if (update) {
                window.location.reload(true);
            }
        }
    },
    mounted() {
        if (!process.env.VUE_APP_VERSION_TIMESTAMP) return;
        this.timerId = setInterval(() => {
            if (!this.dialog && !this.loading) {
                this.checkVersion();
            }
        }, 1000 * 60 * this.intervalMin);
    },
    beforeDestroy() {
        if (!this.timerId) return;
        clearInterval(this.timerId);
    }
};